<template>
  <div class="mb-4">
    <div class="row mt-n2 mb-3 justify-content-center">
      <!-- <div class="col-md-3">
              <input
                  type="text"
                  class="form-control"
                  v-model="serverParams.searchTerm"
                  id="recherche"
                  name="recherche"
                  placeholder="Recherche"
                  @keyup.enter="onSearch"
              />
            </div> -->
      <div class="col-md-5">
        <b-pagination
          @change="getResults"
          :total-rows="rows.total"
          :per-page="serverParams.perPage"
          v-model="serverParams.page"
          size="md"
          :limit="4"
          align="center"
        />
      </div>
      <div class="col-md-4" v-if="rows && rows.total">
        <span class="float-right" style="font-weight: bold"
          >Page : {{ rows.current_page }} /
          {{ Math.ceil(rows.total / serverParams.perPage) }} | Total article :
          {{ rows.total }}</span
        >
      </div>
    </div>
    <div class="row text-center">
      <div class="col-12 my-2">
        <h4>{{ filterName }}</h4>
      </div>
    </div>
    <div class="row mt-n2">
      <div class="col-sm-12">
        <div class="row" v-if="rows && rows.total > 0">
          <div
            class="col-md-4 mb-1 d-flex"
            v-for="article in rows.data"
            :key="article.id"
          >
            <div class="card p-3 bg-white flex-fill w-100">
              <div
                class="text-right mt-2 mr-3"
                v-show="inPanier(article.uuid)"
                style="position: absolute; right: 0"
              >
                <i
                  class="fa fa-shopping-cart text-success"
                  style="font-size: 10px"
                ></i>
              </div>

              <div class="about-product text-center mt-2">
                <img
                  v-if="article.image === null"
                  class="rounded mx-auto d-block"
                  :src="URL_FILE + '/files/no_image_article.png'"
                  alt="Card image"
                />
                <img
                  v-if="article.image"
                  class="rounded mx-auto d-block"
                  :src="URL_FILE + '/files/' + article.image"
                  alt="Card image"
                />
                <div class="mt-3">
                  <h6>
                    {{
                      JSON.parse(article.designation)[locale]
                        ? JSON.parse(article.designation)[locale]
                        : "###"
                    }}
                  </h6>
                </div>
              </div>
              <div class="stats mt-2">
                <!--div class="d-flex justify-content-between p-price mb-1"><span>Famille </span><span>{{ article.famille ? article.famille : '###' }}</span></div-->
                <div class="d-flex justify-content-between mb-0">
                  <span>Référence </span
                  ><span>
                    {{ article.reference ? article.reference : "###" }}</span
                  >
                </div>
                <div class="d-flex justify-content-between mb-0">
                  <span>Code barre </span
                  ><span>{{
                    article.codebarre ? article.codebarre : "###"
                  }}</span>
                </div>
                <div class="d-flex justify-content-between mb-0">
                  <span>Marque </span
                  ><span>{{ article.marque ? article.marque : "###" }}</span>
                </div>
                <div
                  class="d-flex justify-content-between mb-0"
                  v-if="Boolean(user.prix) === true"
                >
                  <span>Prix de vente MRU </span
                  ><span>{{ article.prix_vente_mru | currency }}</span>
                </div>
                <div
                  class="d-flex justify-content-between mb-0"
                  v-if="
                    Boolean(user.stock) === true && article.type === 'stockable'
                  "
                >
                  <span>Stock </span
                  ><span>{{ article.stock + " " + article.unite }}</span>
                </div>
                <div class="d-flex justify-content-center cart-button-box">
                  <button
                    type="button"
                    data-toggle="modal"
                    data-target="#myModal"
                    @click="selectArticle(article.uuid)"
                    v-if="!inPanier(article.uuid)"
                    key="add"
                  >
                    <i class="fas fa-cart-arrow-down text-success"></i>
                    {{ addBtnText }}
                  </button>

                  <button
                    type="button"
                    @click="addPanier(article.uuid)"
                    v-else
                    key="remove"
                  >
                    <i class="fas fa-shopping-cart text-danger"></i>
                    {{ removeBtnText }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-else>
          <div class="col-md-12">
            <p class="text-center display-3 h-100" style="height: 500px">
              Pas d'articles
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- The Modal -->
    <div class="modal fade" id="myModal">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title">Quantité</h4>
            <button
              type="button"
              @click="hideModal"
              class="close"
              data-dismiss="modal"
            >
              &times;
            </button>
          </div>

          <!-- Modal body -->
          <div class="modal-body">
            <form @submit.prevent="addToCart">
              <div class="d-flex justify-content-between">
                <button
                  @click="qty > 0 ? qty-- : null"
                  type="button"
                  class="btn btn-custom btn-danger btn-rounded btn-icon"
                >
                  -
                </button>
                <input
                  type="text"
                  v-model.number="qty"
                  class="form-control qty-input"
                />
                <button
                  @click="qty++"
                  type="button"
                  class="btn btn-custom btn-rounded btn-icon btn-custom-primary"
                >
                  +
                </button>
              </div>
              <div class="d-flex justify-content-center my-3">
                <button class="btn-send" type="submit">Valider</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import URL from "../../../modules/article/service/services";
import constant from "@/constant";

export default {
  name: "articleCards",
  data: function () {
    return {
      URL_FILE: constant.URL_FILE,
      recherche: "",
      rows: {},
      sub_fam: [],
      qty: 1,
      selectedArticle: "",

      serverParams: {
        searchTerm: null,
        sort: {
          field: "reference",
          type: "asc",
        },
        page: 1,
        sfamille: "0",
        perPage: 108,
      },
    };
  },
  computed: {
    addBtnText() {
      return this.getLang("Ajouter", "Add");
    },
    removeBtnText() {
      return this.getLang("Retirer", "Remove");
    },
    filterName() {
      let f = this.$route.params.family;
      let sf = this.$route.params.subfamily;
      if (f) {
        if (sf) {
          return `${f} - ${sf}`;
        }
        return `${f}`;
      }
      return "";
    },
    locale() {
      return this.$store.getters["configapp/locale"];
    },
    user() {
      return this.$store.getters["auth/userp"];
    },
    items: {
      get() {
        return this.$store.getters["cotation/currentCotation"].items;
      },
      set(value) {
        this.$store.dispatch("cotation/setCotation", { items: items });
      },
    },
    sf: {
      get() {
        return this.$store.getters["cotation/filters"].sf;
      },
    },
    assujjeti: function () {
      return this.$store.getters["auth/userp"].assujetti_tva;
    },

    tva() {
      return this.$store.getters["configapp/tva"];
    },

    menus() {
      return this.$store.getters["cotation/menus"];
    },
  },
  watch: {
    /**
     * items(){
      console.log(this.items.length);
    }
     */
    $route(to, from) {
      if (to.name == from.name && to.name === "shop") {
        this.getSetup();
      }
    },
  },
  methods: {
    hideModal() {
      $("#myModal").modal("hide");
      this.selectedArticle = "";
      this.qty = 1;
    },
    addToCart() {
      if (this.selectedArticle && this.qty >= 1) {
        this.addPanier(this.selectedArticle, this.qty);
      }
      this.hideModal();
    },
    selectArticle(articleUUID) {
      this.selectedArticle = articleUUID;
    },
    getLang(fr, en) {
      if (this.locale === "fr") return fr;
      if (this.locale === "en") return en;
      return "";
    },
    inPanier(articleUUID) {
      var objExiste = _.find(this.items, (o) => o.article === articleUUID);

      return !!objExiste;
    },
    addPanier(articleUUID, qty = 1) {
      let self = this;
      let message;

      var objExiste = _.find(self.rows.data, (o) => o.uuid === articleUUID);
      var objCheck = _.find(self.items, (o) => o.article === articleUUID);
      if (objExiste) {
        if (!objCheck) {
          self.items.push({
            article: objExiste.uuid,
            article_libelle: objExiste.designation,
            unite: objExiste.unite_uuid,
            unite_libelle: objExiste.unite,
            prix: objExiste.prix_vente_mru,
            image: objExiste.image,
            tva: self.assujjeti === 1 ? self.tva : 0,
            quantite: qty,
          });
          message = this.getLang(
            "Article ajouté à votre panier",
            "Article added to your cart"
          );
        } else {
          var notificationIndex = _.findIndex(
            self.items,
            (o) => o.article === articleUUID
          );
          self.items.splice(notificationIndex, 1);
          message = this.getLang(
            "Article retiré de votre panier",
            "Article removed from your cart"
          );
        }
        self.$swal({
          position: "top-end",
          icon: "success",
          text: message,
          showConfirmButton: false,
          timer: window.Timer,
        });
      }
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    onSearch: function () {
      this.getResults(1);
    },
    getResults(page = 1, search) {
      this.updateParams({ page: page });
      this.updateParams({ sfamille: this.sf });
      let params = Object.assign({}, this.serverParams);
      if (search) {
        params.searchTerm = search;
      }
      axios
        .get("/cotation/get-all-articles", { params: params })
        .then((response) => {
          this.rows = response.data;
        });
    },
    onFamilleClick(idF) {
      let self = this;
      this.reinitFilter();

      var objExiste = _.find(self.menus, (menu) => menu.id === idF);
      $.each(objExiste.get_sous_famille, function (key, sf) {
        self.addToFilter(sf.id);
      });
    },
    reinitFilter() {
      this.$store.dispatch("cotation/reinitFilterSousFamille");
    },
    addToFilter(idSF) {
      let self = this;
      var objExiste = _.find(self.sf, (id) => id === idSF);

      if (!objExiste) {
        self.sf.push(idSF);
      } else {
        var index = _.findIndex(self.sf, (id) => id === idSF);
        self.sf.splice(index, 1);
      }
    },

    getSetup() {
      if (this.$route.query.search) {
        this.$store
          .dispatch("cotation/setFilterSousFamille", { sf: [] })
          .then(() => {
            this.getResults(null, this.$route.query.search);
          });
      } else {
        this.$store.dispatch("utils/clearSearch");
        if (this.$route.params.family) {
          let family_name = this.$route.params.family;
          let familyObj = _.find(this.menus, (menu) => {
            return JSON.parse(menu.obj_nom)[this.locale] === family_name;
          });
          if (familyObj) {
            if (this.$route.params.subfamily) {
              let subFamilyObj = _.find(familyObj.get_sous_famille, (sf) => {
                return (
                  JSON.parse(sf.obj_nom)[this.locale] ===
                  this.$route.params.subfamily
                );
              });
              if (subFamilyObj) {
                this.reinitFilter();
                this.addToFilter(subFamilyObj.id);
              }
            } else {
              this.onFamilleClick(familyObj.id);
            }
          }

          this.$store
            .dispatch("cotation/setFilterSousFamille", { sf: this.sf })
            .then(() => {
              this.getResults();
            });
        } else {
          this.reinitFilter();
          this.$store
            .dispatch("cotation/setFilterSousFamille", { sf: this.sf })
            .then(() => {
              this.getResults();
            });
        }
      }
    },
  },
  mounted() {
    this.$store.dispatch("cotation/getMenus").then(() => {
      this.getSetup();
    });
    // this.$store.dispatch("configapp/getConfig");
  },
};
</script>

<style scoped lang="scss">
.article-lists-scroll-area {
  width: 100%;
  height: calc(100vh - 360px);
  overflow-y: auto;

  &:not(.ps) {
    overflow-y: auto;
  }
}

.email-content-scroll-area img {
  max-width: 150px;
  max-height: 150px;
}

.about-product {
  img {
    height: 200px;
  }
}

.cart-button-box {
  margin-top: 0.3rem;
  background: rgba(171, 140, 85, 0.075);
  &:hover {
    background: rgba(171, 140, 85, 0.144);
  }
  button {
    padding: 10px 0;
    font-size: 20px;
    width: 100%;
    transition: all 0.5s ease-in-out;
    i {
      font-size: 15px;
    }
  }
}

.article-item {
  cursor: default;
}

.btn-custom {
  border-radius: 50%;
  margin: 0 1rem;
  font-size: 1.2rem;
  font-weight: bold;
}

.btn-custom-primary {
  background: #caaa73;

  &:focus {
    border-color: #f1d198;
    box-shadow: 0 0 0 0.2rem rgba(88, 69, 36, 0.25);
  }

  &:hover {
    background-color: #b19058;
  }
}

.qty-input {
  font-size: 1.3rem;
  font-weight: bold;
  text-align: center;
}
.btn-send {
  padding: 0.5rem 1rem;
  background-color: #caaa73;
  border-radius: 5px;
  font-weight: bold;
}

.btn-send:hover {
  background-color: #b19058;
}
.form-control:focus {
  border-color: #f1d198;
  box-shadow: 0 0 0 0.2rem rgba(88, 69, 36, 0.25);
}
</style>
